

// Import jQUery Validation components as needed
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';

// import 'modernizr';

import './site.js';
import "./mobilenavigation.js";
import "./sidebar.js";
import "./load-events.js";
import "./site.js";
import "./jspdf.min.js";
import "./html2canvas.min.js";
import "./savepdf.js";
import "./metodbanknav.js";
import "./counter.js";
import "./anchor-links.js";
import "./rte-editor.js";
import "./annualyear.js";